import { Component, OnInit, ChangeDetectorRef, Inject, ChangeDetectionStrategy, ViewChild, ElementRef } from "@angular/core";
import { PagingHelper } from "../../shared/pagingHelper";
import { SortOption } from "../../shared/models/sort.model";
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from "@angular/material";
import { CoreLogService } from "../../services/log.service";
import { SnackBarService } from "../../services/snackBar.service";
import { SortDirection } from "../../shared/contentTypes";

@Component({
  selector: "ya-registrationLocationDialog",
  templateUrl: "./registrationLocationDialog.component.html",
  styleUrls: ["./registrationLocationDialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RegistrationLocationDialogComponent implements OnInit {
  @ViewChild("locationListView") locationListView: ElementRef;
  public locations: any[];
  private sortOption: SortOption[];
  private pagingHelper: PagingHelper;

  constructor(public bottomSheetRef: MatBottomSheetRef<RegistrationLocationDialogComponent>,
    private _changeDetectorRef: ChangeDetectorRef,
    private _coreLogService: CoreLogService,
    @Inject(MAT_BOTTOM_SHEET_DATA) public locationDialogData: number[]) {
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("NewsComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  ngOnInit() {
    const me = this;
    me.pagingHelper = new PagingHelper();
    me.sortOption = [];
    if (me.locationDialogData["registered"]) {
      me.sortOption.push(me.pagingHelper.createSortOption("like", SortDirection.DESC));
    }
    me.sortOption.push(me.pagingHelper.createSortOption("selected", SortDirection.DESC));
    me.sortOption.push(me.pagingHelper.createSortOption("sort_nr", SortDirection.ASC));
    me.ReloadDataAndRender();
    me.PushChanges();
  }

  public ReloadDataAndRender(): void {
    const me = this;
    me.locations = me.setSelectedLocations(me.locationDialogData["locationData"]);
    me.locations.sort(me.pagingHelper.fieldSorter(me.sortOption));
    me.PushChanges();
    me.setLocationsStyle();
  }

  public toggleFilterSelection(location: any): void {
    const me = this;
    location.selected = !location.selected;
    me.locations.sort(me.pagingHelper.fieldSorter(me.sortOption));
    me.PushChanges();
    setTimeout(() => {
      me.setLocationsStyle();
    }, 200);
  }

  private setSelectedLocations(locations: any[]): any[] {
    const me = this;
    locations.forEach((location, index) => {
      location.position = index;
      if (me.locationDialogData["locationIds"].includes(location.hyp_cus_nr) || location.like) {
        location.selected = true;
      } else {
        location.selected = false;
      }
    });
    return locations;
  }

  // set style for location list for animation effect
  private setLocationsStyle() {
    const me = this;
    const vh: number = +document.documentElement.style.getPropertyValue("--vh").replace("px", "");
    const itemList: HTMLElement[] = Array.from(me.locationListView.nativeElement.getElementsByTagName("a"));
    let topOffset = 0;
    itemList.forEach(element => {
      element.style.position = "absolute";
      element.style.top = topOffset + "px";
      topOffset += element.clientHeight;
    });
    if (topOffset < (60 * vh)) {
      me.locationListView.nativeElement.style.height = topOffset + "px";
    } else {
      me.locationListView.nativeElement.style.height = (60 * vh) + "px";
    }
    // me.locationsSubscription.unsubscribe();
  }

  public setUserLocation(): void {
    const me = this;
    this.bottomSheetRef.dismiss(me.locations.filter(l => l["selected"]).map(s => s["hyp_cus_nr"]));
  }

}
